import { ConfigProvider } from 'antd'
import { Outlet } from 'react-router-dom'
import zhCN from 'antd/locale/zh_CN'

// PC 端页面入口, 有其他配置的可以在这里添加
export const PcApp = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#FF7006',
          colorPrimaryHover: '#FF6D00',
        },
      }}
    >
      <Outlet />
    </ConfigProvider>
  )
}
